import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "posthog-js/react";
import { trackTwitterPageView } from "@/utils/twitterPixel";

// Declare gtag function for TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    // Track page view in Google Analytics when route changes
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-M7MWX19FM0', {
        page_path: pathname + (hash || ''),
      });
    }
    
    // Track pageview in PostHog
    if (posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        path: pathname + (hash || ''),
      });
    }
    
    // Track page view in Twitter/X Pixel
    // Twitter Pixel tracks page views automatically, but we ensure it's tracked on route changes
    trackTwitterPageView();

    // Only scroll to top if there's no hash in the URL
    if (!hash) {
      // Immediate scroll
      window.scrollTo(0, 0);
      // Also use requestAnimationFrame to ensure it happens after render
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
      // Additional scrolls to catch any late updates
      const timeouts = [
        setTimeout(() => window.scrollTo(0, 0), 10),
        setTimeout(() => window.scrollTo(0, 0), 50),
        setTimeout(() => window.scrollTo(0, 0), 100),
      ];
      
      return () => {
        timeouts.forEach(timeout => clearTimeout(timeout));
      };
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;

